import { format } from "date-fns";
import { StyleEnums } from "models/enums";
import { MessageBubbleDetails } from "models/propTypes/messagePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

const { EmploymentTerminationReason } = WintSuperkollAPIModel;

/** Wint Lön writes the vacation debt off for these reasons, so nothing is deducted to warn about. */
const debtWrittenOff = [
  EmploymentTerminationReason.Sickness,
  EmploymentTerminationReason.Redundancy,
  EmploymentTerminationReason.Death,
];

/** Core binds the end date as a calendar day, so a time part or a UTC shift would be rejected or move the day. */
export const toDateOnly = (value: unknown): string | undefined => {
  if (!value) return undefined;
  const date = new Date(value as string | Date);
  return isNaN(date.getTime()) ? undefined : format(date, "yyyy-MM-dd");
};

/** Field message for an end date that can leave paid but unearned vacation days to settle on the final salary. */
export const createConcurrentVacationWarning = (
  fetchIsConcurrent: (endDate: string) => Promise<boolean>,
  savedEndDate: unknown,
  messages: { withoutReason: () => string; withReason: () => string }
) => {
  const saved = toDateOnly(savedEndDate);
  const answers = new Map<string, Promise<boolean>>();

  return async (
    endDate: unknown,
    terminationReason?: WintSuperkollAPIModel.EmploymentTerminationReason
  ): Promise<MessageBubbleDetails | undefined> => {
    const day = toDateOnly(endDate);
    if (!day || day === saved || (terminationReason != null && debtWrittenOff.includes(terminationReason)))
      return undefined;

    if (!answers.has(day))
      answers.set(
        day,
        fetchIsConcurrent(day).catch(() => false)
      );
    if (!(await answers.get(day))) return undefined;

    return {
      type: StyleEnums.DisplayType.Warning,
      message: terminationReason ? messages.withReason() : messages.withoutReason(),
    };
  };
};
